// Sample hard-coded boards: a normal round and a "Double Jeopardy" round.
// A clue's `type` is "text" or "image" (an image clue's `prompt` is a URL shown instead of text).

function makeClues(values, prompts, answers) {
    return values.map((value, i) => ({
        value,
        type: "text",
        prompt: prompts[i],
        answer: answers[i],
    }));
}

function textClues(prompts, answers) {
    return makeClues([200, 400, 600, 800, 1000], prompts, answers);
}

function textCluesDouble(prompts, answers) {
    return makeClues([400, 800, 1200, 1600, 2000], prompts, answers);
}

const round1 = {
    name: "Jeopardy!",
    categories: [
        "Erynos Geography",
        "Monsters & Beasts",
        "Rules Lawyering",
        "Famous NPCs",
        "Magic Items",
        "Potpourri",
    ],
    clues: [
        textClues(
            [
                "The largest city on the continent, and a hub for magical research.",
                "This coastal metropolis is known for its skyport and busy harbor.",
                "The type of terrain that separates the northern and southern kingdoms.",
                "This city trains the realm's arcane scholars.",
                "The body of water that Port Aurion sits on.",
            ],
            [
                "What is Arcanithralis?",
                "What is Draktharion?",
                "What are mountains?",
                "What is Collegium Arcana?",
                "What is the sea?",
            ]
        ),
        textClues(
            [
                "This undead creature drains levels with a single touch.",
                "A dragon's breath weapon is determined by this trait.",
                "This ooze can split in two when struck with slashing damage.",
                "The condition inflicted by a mind flayer's tentacle attack.",
                "This fey creature is known for granting wishes, with a twist.",
            ],
            [
                "What is a wight?",
                "What is its type/color?",
                "What is a gelatinous cube?",
                "What is stunned?",
                "What is a djinni?",
            ]
        ),
        textClues(
            [
                "The ability score most often used for stealth checks.",
                "This condition means a creature can't take actions or reactions.",
                "The number of death saves needed to stabilize.",
                "This action lets you move without provoking opportunity attacks.",
                "The saving throw type most commonly used against fireball.",
            ],
            [
                "What is Dexterity?",
                "What is paralyzed?",
                "What is 3?",
                "What is the Disengage action?",
                "What is Dexterity?",
            ]
        ),
        textClues(
            [
                "The mysterious cloaked merchant who always seems to know too much.",
                "The tyrannical duke ruling over Dathimor.",
                "This retired adventurer now runs the tavern in Thornhaven.",
                "The archmage who leads the Collegium Arcana.",
                "This dragon has been terrorizing trade routes near Draktharion.",
            ],
            [
                "Who is the party's DM's favorite NPC to guess?",
                "Who is Duke Dathimor?",
                "Who is the tavernkeeper?",
                "Who is the archmage?",
                "Who is the dragon?",
            ]
        ),
        textClues(
            [
                "This wondrous item grants advantage on saving throws against being charmed or frightened.",
                "This cloak lets its wearer become invisible for one minute.",
                "This ring lets you cast Fireball once per day.",
                "This item type must be attuned before it works at full strength.",
                "This +1 weapon's damage type also does necrotic damage on a critical hit.",
            ],
            [
                "What is a Cloak of Protection (or similar)?",
                "What is a Cloak of Invisibility?",
                "What is a Ring of Fire Elemental Command (or similar)?",
                "What is a magic item?",
                "Up to your table to answer!",
            ]
        ),
        textClues(
            [
                "This image shows the party's current continent.",
                "The number of players in this campaign.",
                "This snack is mandatory at every session.",
                "The die you roll for a critical hit's extra damage.",
                "The last thing the party did before this session.",
            ],
            [
                "What is Erynos?",
                "What is however many are in your group?",
                "What are chips?",
                "What is the same die as the attack?",
                "What is... up to your table to answer!",
            ]
        ),
    ],
};

// Swap one clue for an image example.
round1.clues[5][0] = {
    value: 200,
    type: "image",
    prompt: "/logo512.png",
    answer: "What is a placeholder image?",
};

const round2 = {
    name: "Double Jeopardy!",
    categories: [
        "Campaign History",
        "Spells & Magic",
        "Loot & Treasure",
        "Guess the Voice",
        "Memorable NPCs",
        "Session Zero",
    ],
    clues: [
        textCluesDouble(
            [
                "The session number where the party first met.",
                "The first major villain the party defeated.",
                "The city the campaign started in.",
                "The quest that took the longest to finish.",
                "The reason the party first left their home city.",
            ],
            [
                "What is session 1?",
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
            ]
        ),
        textCluesDouble(
            [
                "This spell creates an illusory duplicate of the caster.",
                "The school of magic that includes fireball.",
                "This spell lets you speak with the dead.",
                "The level of spell slot needed to cast Counterspell at its base level.",
                "This cantrip does necrotic damage and steals life.",
            ],
            [
                "What is Mirror Image?",
                "What is Evocation?",
                "What is Speak with Dead?",
                "What is 3rd level?",
                "What is Chill Touch?",
            ]
        ),
        textCluesDouble(
            [
                "The rarest magic item the party currently owns.",
                "The currency used most often in Erynos.",
                "This item type needs attunement to use its full power.",
                "The most gold ever found in a single haul.",
                "The item the party still hasn't identified.",
            ],
            [
                "Up to your table to answer!",
                "What is gold?",
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
            ]
        ),
        textCluesDouble(
            [
                "This player always does the worst NPC accents.",
                "This player's character has died the most times.",
                "This player rolls the most natural 20s.",
                "This player is most likely to start a bar fight.",
                "This player always has snacks.",
            ],
            [
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
            ]
        ),
        textCluesDouble(
            [
                "The mysterious cloaked merchant who always seems to know too much.",
                "The tyrannical duke ruling over Dathimor.",
                "This retired adventurer now runs the tavern in Thornhaven.",
                "The archmage who leads the Collegium Arcana.",
                "This dragon has been terrorizing trade routes near Draktharion.",
            ],
            [
                "Who is the party's DM's favorite NPC to guess?",
                "Who is Duke Dathimor?",
                "Who is the tavernkeeper?",
                "Who is the archmage?",
                "Who is the dragon?",
            ]
        ),
        textCluesDouble(
            [
                "The house rule everyone forgets.",
                "The dice everyone fights over.",
                "The snack that caused the biggest mess at the table.",
                "The homebrew rule that changed the game the most.",
                "The best moment of the whole campaign so far.",
            ],
            [
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
                "Up to your table to answer!",
            ]
        ),
    ],
};

const boardData = {
    rounds: [round1, round2],
};

export default boardData;
